/** @file Assets panel: images and attachments of the open document (DocumentPanel shows the no-project note). */
import type { IDockviewPanelProps } from 'dockview-react';
import { DocumentPanel } from '../../forms/DocumentPanel';
import { AssetsTree } from './AssetsTree';

/** Selecting a row focuses it in the Inspector. */
export function AssetsPanel({ api }: IDockviewPanelProps) {
  return <DocumentPanel api={api} view={(doc, t) => <AssetsTree doc={doc} t={t} />} />;
}
